import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WordpressService } from './wordpress.service';

@Injectable({
  providedIn: 'root'
})
export class OxancefrService extends WordpressService {

	get baseUrl () {return 'https://www.oxance.fr/wp-json/wp/v2/'};
	get baseHeaders () {return {'Authorization': 'Basic cG9ydGFpbDpUYnNsIGhQVzggSFlXQiBGME1qIGhiSU0gbjlERg=='}};

	constructor(http: HttpClient) { super(http); }
}